import API from '@/api'

export default {
  namespaced: true,

  state: () => ({
    hasPublications: false,
    siteName: null,
    siteUrl: null,
    type: null,
    averageDuration: null,
    fullTeacherFio: false,
    hideWindowGroups: false,
    hideEmptyDay: false,
    lessonsColumnDirection: false,
    showCabinets: false,
  }),

  getters: {
    isSchool(state) {
      return ['School', 'Lyceum'].includes(state.type)
    },

    averageDuration(state) {
      return state.averageDuration || 0
    },

    fullTeacherFio(state) {
      return state.fullTeacherFio
    },

    hideWindowGroups(state) {
      return state.hideWindowGroups
    },

    hideEmptyDay(state) {
      return state.hideEmptyDay
    },

    lessonsColumnDirection(state) {
      return state.lessonsColumnDirection
    }
  },

  mutations: {
    update(state, payload) {
      _.extend(state, payload)
    },
  },

  actions: {
    async fetch({ commit }, publicationId) {
      commit('update', await API.getBootstrap(publicationId))
    },
  }
}
